module.exports = __webpack_public_path__ + "static/OleksandrLomakovskyi-539ecf4034399933ff836bd9d3de8c7d.jpeg";